/*
 * @Author: yq05535 Lenna_Huang@intretech.com
 * @Date: 2022-08-10 11:46:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-27 09:51:48
 * @FilePath: /project/src/api/login.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '../request'
export default {
    
    /**
     * 登录
     */
    login: (para, suss, err) => request.request('client/sys/applicationLogin', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 注册
     */
    applicationRegister: (para, suss, err) => request.request('client/register/applicationRegister', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 获取验证码
     */
    SendMessage: (para, suss, err) => request.request('sendMsg/SendMessage', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

    /**
     * 绑定邮箱并发送验证码
     */
    bindEmailAndSend: (para, suss, err) => request.request('sendMsg/bindEmailAndSend', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 校验验证码
     */
    validate: (para, suss, err) => request.request('sendMsg/validate', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 校验是否注册
     */
    isRegister: (para, suss, err) => request.request('client/register/isRegister', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

    /**
     * 校验邮箱是否注册
     */
    isRegisterEmail: (para, suss, err) => request.request('client/register/isRegisterEmail', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

    /**
     * 忘记密码
     */
    changPassword: (para, suss, err) => request.request('forgetPassword/changPassword', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 绑定账号
     */
    relevanceAccount: (para, suss, err) => request.request('wx/relevanceAccount', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 校验是否绑定
     */
    checkExistRelevance: (para, suss, err) => request.request('wx/checkExistRelevance', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 绑定手机号
     */
    completeMobile: (para, suss, err) => request.request('wx/completeMobile', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

}


// WEBPACK FOOTER //
// ./src/api/login.js